import Helpers from "../../resources/js/utils/helpers";

export default class VideosSort extends Helpers {
  constructor() {
    super();
    Helpers.registerHandler(
      "click",
      this.toggleDropdown.bind(this),
      ".sort-dropdown__trigger",
    );
    this.initOutsideClick();
  }

  toggleDropdown(el, e) {
    e.stopPropagation();
    const dropdown = el.closest(".sort-dropdown");
    if (!dropdown) return;

    dropdown.classList.toggle("is-open");

    document.querySelectorAll('.sort-dropdown.is-open').forEach(openDropdown => {
      if (openDropdown !== dropdown) {
        openDropdown.classList.remove('is-open');
      }
    });
  }

  initOutsideClick() {
    document.addEventListener("click", (e) => {
      const openDropdown = document.querySelector(".sort-dropdown.is-open");
      
      if (openDropdown && !openDropdown.contains(e.target)) {
        openDropdown.classList.remove("is-open");
      }
    });
  }
}

new VideosSort();